
export const Account = {
  GetSMSVerificationCode: {
    method: 'post',
    path: '/api/LeadAccount/GetSMSVerificationCode'
  },
  Login: {
    method: 'post',
    path: '/api/LeadAccount/LeadLogin'
  },
  SimpleLogin: {
    method: 'post',
    path: '/api/LeadAccount/SimpleLogin'
  },
  AlumniLogin: {
    method: 'post',
    path: '/api/LeadAccount/AlumniLogin'
  },
  ReallyAlumniLogin: {
    method: 'post',
    path: '/api/LeadAccount/AlumniLogin'
  },
  GetBaseInfo: {
    method: 'get',
    path: '/api/LeadAccount/GetLeadBasicInfo'
  },
  UpdatePortrait: {
    method: 'post',
    path: '/api/LeadAccount/UpdateLeadPortrait'
  },
  UpdateResume: {
    method: 'post',
    path: '/api/LeadAccount/UpdateLeadResume'
  },
  UpdateBaseInfo: {
    method: 'post',
    path: '/api/LeadAccount/UpdateLeadBaseInfo'
  },
  RefreshToken: {
    method: 'post',
    path: '/api/LeadAccount/RefreshToken'
  },
  RevokeToken: {
    method: 'post',
    path: '/api/LeadAccount/RevokeToken'
  },
  SaveSurvey: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveSurveyResult'
  },
  CheckUserExist: {
    method: 'post',
    path: '/api/LeadAccount/GetMobileExist'
  },
  GetLeadCouponList: {
    method: 'get',
    path: '/api/LeadAccount/GetCoupons'
  }
}

export const Event = {
  GetTopTenEvents: {
    method: 'get',
    path: '/api/LeadEvents/GetTopTenEvents'
  },
  GetRegistedEvents: {
    method: 'get',
    path: '/api/LeadEvents/GetRegistedEvents'
  },
  GetApprovedRegistedEvents: {
    method: 'get',
    path: '/api/LeadEvents/GetApprovedRegistedEvents'
  },
  GetEventById: {
    method: 'get',
    path: '/api/LeadEvents/GetEventById'
  },
  LeadRegisterEvent: {
    method: 'post',
    path: '/api/LeadEvents/LeadRegisterEvent'
  },
  GetEventsByCode: {
    method: 'get',
    path: '/api/PublicEventRegister/GetEventsByCode'
  },
  GetCampaignIdByCode: {
    method: 'get',
    path: '/api/PublicEventRegister/GetCampaignIdByCode'
  },
  GetEventsByCodeLang: {
    method: 'get',
    path: '/api/PublicEventRegister/GetEventsByCodeLang'
  }
}

export const Wechat = {
  GetWxUser: {
    method: 'get',
    path: '/api/WeChartSource/GetWxUser'
  },
  GetWxUserForUrl: {
    method: 'get',
    path: '/api/WeChartSource/GetWxUserForUrl'
  },
  GetWxUserForLead: {
    method: 'get',
    path: '/api/WeChartSource/GetWxUserForLead'
  },
  GetWxSignature: {
    method: 'get',
    path: '/api/WeChartSource/GetWxSignature'
  }
}

export const PublicEvent = {
  GetLookups: {
    method: 'get',
    path: '/api/PublicEventRegister/GetLookups'
  },
  ApplyForCounselling: {
    method: 'post',
    path: '/api/PublicEventRegister/ApplyForCounselling'
  },
  GetNewSurvey: {
    method: 'get',
    path: '/api/PublicEventRegister/GetNewSurvey'
  },
  CheckLeadIsRegistered: {
    method: 'get',
    path: '/api/PublicEventRegister/CheckLeadIsRegistered'
  },
  SaveNewSurveyAnswer: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveNewSurveyAnswer'
  },
  SaveAnonymousSurveyAnswer: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveAnonymousSurveyAnswer'
  },
  GetSurveyAnswers: {
    method: 'get',
    path: '/api/PublicEventRegister/GetSurveyAnswers'
  },
  SaveSurveyResultWithToken: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveSurveyResultWithToken'
  },
  GetVideoList: {
    method: 'get',
    path: '/api/OnlineCourse/GetCoursesByType'
  },
  ValidateVideoCode: {
    method: 'get',
    path: '/api/OnlineCourse/GetCourseVideoPath'
  },
  GetCaptcha: {
    method: 'get',
    path: '/api/LeadAccount/GetCaptcha'
  },
  UploadFilesWithSign: {
    method: 'post',
    path: '/api/PublicEventRegister/UploadFilesWithSign'
  },
  // ic assistant
  GetICLeadsByCode: {
    method: 'post',
    path: '/api/PublicEventRegister/GetICLeadsByCode'
  },
  GetICFinalLeadsByCode: {
    method: 'post',
    path: '/api/PublicEventRegister/GetICFinalLeadsByCode'
  },
  SaveICJudgeScore: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveICJudgeScore'
  },
  GetICLeads: {
    method: 'get',
    path: '/api/PublicEventRegister/GetICTypeLeads'
  },
  SaveICAMorPMScore: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveICAMorPMScore'
  }
}

export const Apply = {
  GetLookups: {
    method: 'get',
    path: '/api/AnchorApply/GetLookups'
  },
  GetAnchorApplicationForm: {
    method: 'get',
    path: '/api/AnchorApply/GetAnchorApplicationForm'
  },
  SaveAnchorApplication: {
    method: 'post',
    path: '/api/AnchorApply/SaveAnchorApplication'
  },
  SubmitAnchorApplication: {
    method: 'post',
    path: '/api/AnchorApply/SubmitAnchorApplication'
  },
  SaveIntakeInfo: {
    method: 'post',
    path: '/api/AnchorApply/SaveIntakeInfo'
  },
  GetIntakeLookups: {
    method: 'get',
    path: '/api/AnchorApply/GetIntakeLookups'
  },
  GetIntakeInfo: {
    method: 'get',
    path: '/api/AnchorApply/GetIntakeInfo'
  }
}

export const EmployabilityAssessment = {
  GetEAForm: {
    method: 'get',
    path: '/api/EmployabilityAssessment/GetEAForm'
  },
  SaveEAForm: {
    method: 'post',
    path: '/api/EmployabilityAssessment/SaveEAForm'
  },
  SubmitEAForm: {
    method: 'post',
    path: '/api/EmployabilityAssessment/SubmitEAForm'
  },
  SendEAReport: {
    method: 'post',
    path: '/api/EmployabilityAssessment/SendEAReport'
  }
}
// Minisite
export const PublicMiniSite = {
  GetArticles: {
    method: 'post',
    path: '/api/PublicMiniSite/GetArticles'
  },
  GetArticleById: {
    method: 'get',
    path: '/api/PublicMiniSite/GetArticleById'
  }
}
// Sharing
export const Sharing = {
  GetInfoById: {
    method: 'get',
    path: '/api/Sharing/GetInfoById'
  },
  UpdateInfo: {
    method: 'post',
    path: '/api/Sharing/UpdateInfo'
  },
  GetSharingWords: {
    method: 'get',
    path: '/api/Sharing/GetSharingWords'
  }
}

// Ic-test
export const IcTest = {
  SaveICAMorPMScore: {
    method: 'post',
    path: '/api/PublicEventRegister/SaveICAMorPMScore'
  }
}
